import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {
  Paper,
  withStyles,
} from '@material-ui/core'

import { createCSV } from '../helpers'
import Modal from './Modal'
import Loading from './Loading'
import Pagination from './Pagination'


const styles = theme => ({
  root: {
    marginTop: theme.spacing(2),
  },
  disableMargin: {
    marginTop: 0,
  },
})


class Automation extends PureComponent {
  /* LIFECYCLE */

  state = {
    pendingCSV: false,
  }


  /**
   * @componentWillMount
   */
  componentDidMount() {
    if (this.props.request) {
      this.handleFirst()
    }
  }

  componentDidUpdate(prevProps) {
    const { items, isLoading } = this.props

    /*
    if (request && request !== prevProps.request) {
      this.handleFirst()
    }
    */

    if (items !== prevProps.items && items.length > 0 && !isLoading && this.state.pendingCSV) {
      this.handleCreateCSV(items)
    }
  }


  /* METHODS */

  /**
   * Handle export data to CSV
   */
  handleExport = async () => {
    this.setState({ pendingCSV: true })

    this.props.request({
      limit: 1000,
    })
  }

  handleCreateCSV = (items) => {
    const { row, head, csvTitle } = this.props

    createCSV(head, items.map((item) => {
      const values = row(item)

      if (Array.isArray(values)) {
        return values.map(v => typeof v === 'object' ? v.data : v)
      }

      return typeof values === 'object' ? values.data : values
    }), csvTitle)

    this.setState({
      pendingCSV: false,
    }, this.handleFirst)
  }

  handleFirst = () => {
    const { onPageChange } = this.props

    if (onPageChange) {
      onPageChange()
    }

    this.props.request()
  }

  handleNext = () => {
    const { onPageChange } = this.props

    if (onPageChange) {
      onPageChange()
    }

    this.props.request({ startAfter: this.props.startAfter })
  }

  handlePrevious = () => {
    const { onPageChange } = this.props

    if (onPageChange) {
      onPageChange()
    }

    this.props.request({ endBefore: this.props.endBefore })
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      items,
      classes,
      hasMore,
      children,
      isLoading,
      className,
      hasPrevious,
      disableMargin,
    } = this.props
    const {
      pendingCSV,
    } = this.state

    return (
      <Paper
        className={classNames(classes.root, {
          [classes.disableMargin]: disableMargin,
        }, className)}
      >
        {isLoading && <Loading />}
        {children}

        <Pagination
          hasMore={hasMore}
          count={items.length}
          isLoading={isLoading}
          onNext={this.handleNext}
          hasPrevious={hasPrevious}
          onFirst={this.handleFirst}
          onExport={this.handleExport}
          onPrevious={this.handlePrevious}
          onPageChange={this.handlePageChange}
        />

        <Modal
          open={pendingCSV}
          onClose={() => {}}
          title="Export en cours..."
        >
          <Loading
            secondary
            text="Veuillez patienter..."
          />
        </Modal>
      </Paper>
    )
  }
}


Automation.defaultProps = {
  row: [],
  head: [],
  items: [],
}


Automation.propTypes = {
  row: PropTypes.func,
  hasMore: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
  endBefore: PropTypes.any,
  isLoading: PropTypes.bool,
  startAfter: PropTypes.any,
  csvTitle: PropTypes.string,
  hasPrevious: PropTypes.bool,
  className: PropTypes.string,
  onPageChange: PropTypes.func,
  disableMargin: PropTypes.bool,
  request: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  items: PropTypes.arrayOf(PropTypes.object),
  head: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object])),
}


export default withStyles(styles)(Automation)
